import Sprite from '../sprites/sprite';
import clsx from 'clsx';
import React, { useRef, useState } from 'react';

interface AccordionProps {
  title: string;
  content: React.ReactNode;
  className?: string;
  icon?: React.ReactNode;
}

export const Accordion: React.FC<AccordionProps> = ({
  title,
  content,
  className,
  icon,
}) => {
  const answerRef = useRef<HTMLParagraphElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    <details
      open={isOpen}
      onClick={(e) => {
        const element = e.target as HTMLElement;
        if (!(element.contains(answerRef.current) || element.tagName === 'A')) {
          e.preventDefault();
          setIsOpen((prev) => !prev);
        }
      }}
      className={`py-4 px-5 md:px-6 font-bold cursor-pointer select-none ${className} transition`}
    >
      <summary className="flex flex-row items-center justify-between font-semibold gap-3">
        <div className="flex items-center gap-3">
          {icon && <span className="text-amber-600 flex-shrink-0">{icon}</span>}
          <span className="text-amber-900">{title}</span>
        </div>
        <div
          className={clsx(
            'w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0 transition-colors',
            {
              'bg-amber-200': isOpen,
            },
          )}
        >
          <Sprite
            name="down"
            width="56"
            height="30"
            className={clsx('w-3 h-2 transition-transform', {
              'rotate-180': isOpen,
            })}
            stroke="#92400e"
            strokeWidth={6}
          />
        </div>
      </summary>
      <div
        ref={answerRef}
        className="mt-4 font-normal font-sans not-italic text-base text-gray-700 leading-relaxed pl-0 md:pl-9"
      >
        {content}
      </div>
    </details>
  );
};
